
import logo from './utils/clown-pepe-the-frog.gif'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Better Luck Next Time
        </p>
      
      </header>
    </div>
  );
}

export default App;
